import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84e1af46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tp-tile-blur__absolute" }
const _hoisted_2 = {
  width: "84",
  height: "120",
  viewBox: "0 0 84 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_3 = { filter: "url(#filter0_f)" }
const _hoisted_4 = ["fill"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("filter", {
    id: "filter0_f",
    x: "-22.2506",
    y: "0.54044",
    width: "127.869",
    height: "100.745",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /*#__PURE__*/_createElementVNode("feFlood", {
      "flood-opacity": "0",
      result: "BackgroundImageFix"
    }),
    /*#__PURE__*/_createElementVNode("feBlend", {
      mode: "normal",
      in: "SourceGraphic",
      in2: "BackgroundImageFix",
      result: "shape"
    }),
    /*#__PURE__*/_createElementVNode("feGaussianBlur", {
      stdDeviation: "19.3741",
      result: "effect1_foregroundBlur"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("g", _hoisted_3, [
        _createElementVNode("path", {
          d: "M66.8701 50.913C66.8701 57.333 55.5938 62.5375 41.6838 62.5375C27.7738 62.5375 16.4976 57.333 16.4976 50.913C16.4976 44.493 27.7738 39.2886 41.6838 39.2886C55.5938 39.2886 66.8701 44.493 66.8701 50.913Z",
          fill: $props.color
        }, null, 8, _hoisted_4)
      ]),
      _hoisted_5
    ]))
  ]))
}